import { render, staticRenderFns } from "./ActionsMenuLegacy.vue?vue&type=template&id=50b22833&scoped=true&"
import script from "./ActionsMenuLegacy.vue?vue&type=script&lang=ts&"
export * from "./ActionsMenuLegacy.vue?vue&type=script&lang=ts&"
import style0 from "./ActionsMenuLegacy.vue?vue&type=style&index=0&id=50b22833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b22833",
  null
  
)

export default component.exports